import React from 'react';

export const KeycardHole = () => (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.70154 8.09464C8.02598 7.34552 8.91973 5.94524 8.91973 4.33735C8.91973 1.94189 6.94093 0 4.5 0C2.05907 0 0.080249 1.94189 0.080249 4.33735C0.080249 5.94524 0.973977 7.34552 2.29842 8.09464L0 16H9L6.70154 8.09464Z"
      fill="var(--keycard-key-color)"
    />
  </svg>
);
